import { baseUrl } from '@/api/types';

export function periodicInvoiceIndexUrl() {
  return `${baseUrl}/periodic-invoices`;
}

export function periodicInvoiceCreateUrl() {
  return `${periodicInvoiceIndexUrl()}/create`;
}

export function periodicInvoiceEditUrl(invoiceId) {
  return `${periodicInvoiceIndexUrl()}/${invoiceId}/edit`;
}

export function periodicInvoiceDetailsUrl(invoiceId) {
  return `${periodicInvoiceIndexUrl()}/${invoiceId}/details`;
}

export function periodicInvoiceStoreUrl() {
  return periodicInvoiceIndexUrl();
}

export function periodicInvoiceUpdateUrl(invoiceId) {
  return `${periodicInvoiceIndexUrl()}/${invoiceId}`;
}

export function periodicInvoiceDeleteUrl(invoiceId) {
  return `${periodicInvoiceIndexUrl()}/${invoiceId}`;
}

export function periodicInvoicePauseUpdateUrl(invoiceId) {
  return `${baseUrl}/periodic-invoices/pause/${invoiceId}`;
}

export function periodicInvoiceArchiveStoreUrl(invoiceId) {
  return `${baseUrl}/periodic-invoices/${invoiceId}/archive`;
}

export function periodicInvoiceRequisitesIndexUrl(invoiceId) {
  return `${baseUrl}/periodic-invoice-requisites/${invoiceId}`;
}

export function periodicInvoiceMassActionUrl() {
  return `${periodicInvoiceIndexUrl()}/mass-actions`;
}

export function periodicInvoiceImportCreateUrl() {
  return `${periodicInvoiceIndexUrl()}/import/create`;
}

export function periodicInvoiceImportStoreUrl() {
  return `${periodicInvoiceIndexUrl()}/import`;
}
